<template>
    <div ref="translateIn" class="translate-in" :class="translateClass">
        <slot />
    </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";

export default {
    name: "translate-in",
    setup() {
        const translateIn = ref();

        const translateClass = computed(() => {
            return {
                "translate-active": state.value,
            };
        });

        const state = ref(true);

        onMounted(() => {
            addEventListener("scroll", () => {
                state.value =
                    window.innerHeight >
                    translateIn.value.getBoundingClientRect().top;
            });
        });

        return {
            translateIn,
            translateClass,
        };
    },
};
</script>

<style lang="scss">

@use "../scss/design-library/grid";

@include grid.media-query_(mobile) {
    .translate {
        &-in {
            transform: translateY(100px);
            &.translate-active {
                transform: unset;
                animation: translateIn ease-out 200ms;
            }
        }
    }
    @keyframes translateIn {
        from { transform: translateY(100px); }
        to { transform: translateY(0); }
    }
}

</style>
